import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as fuiRedux from "../../../redux/fui/index";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Grid, FormGroup, Checkbox, FormControlLabel, FormLabel, DialogActions, Radio } from "@material-ui/core";
import {
  StyledTooltip,
  StyledFormControl,
  StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "../FuiStyles";
import {
  longTextEndDate,
  rootExistedHint,
  rootWrongFormatHint,
} from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import priceConfig from "./pricetotierMapping";
// import TextsmsIcon from "@material-ui/icons/Textsms";
import {
  checkServiceNowTicket,
  checkWBSECode,
  checkBenefitsExpected,
  checkConcurrentUsers,
  checkMonthlyTicketVolume,
  checkPOCname,
  createMaxDate
} from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2, DeclineButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';
import { forEach } from "lodash";
import { GWLFormModel } from "../../../constants/formModels";
import { is } from "date-fns/locale";


const aSelectedInstanceFields = {
  DMSId: { type: "string", fieldName: "dmsId" },
  ClientName: { type: "string", fieldName: "clientName" },
  DeployRegion: { type: "object", fieldName: "deployRegion" },
  SAPContractID: { type: "object", fieldName: "sapContractId" },
  AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};
/**
 * Dedicated Platform Form
 * @author Shilpa Adikeshava
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */

const GenWizardPlatform = ({
  values, // the value would be changed by user's input
  updateGWLForm, //the function to update GWLForm values which is from redux
  updateASelectedInstanceByField,
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  minDate,
  maxDate,
  isServiceEndDateInvalid,
  getSelectedEnvironment,
  getServiceEndDate,
  getNotesValue,
  //   getUsersValue,
  //   userValidations,
  notesValidations,
  configurationType,
  classes,
  history,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

  // open the dialog when user choose Yes in GDPR
  const config = configurationType === "quick";
  const [isMonthlyTicketVolumeValid, setIsMonthlyTicketVolumeValid] = useState(
    true
  );

  // Use enhanced validation hook with red borders and dialog management
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

  // check whether values are valid
  const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);
  const [serviceNowAPIValid, setServiceNowAPIValid] = useState(null);
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isConcurrentUsersValid, setIsConcurrentUsersValid] = useState(true);
  const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
  const [isNoteVisible, setNoteVisible] = useState(true);
  const [selectedApps, setSelectedApps] = useState([]);


  //   const [isUsersFieldValid, setUsersField] = useState(false);

  const isGDPR = values.GDPR === "yes";
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [errorADGroup, setErrorADGroup] = useState(false);
  const [errorSADGroup, setErrorSADGroup] = useState(false);
  const [isADSADUnique, setIsADSADUnique] = useState(false);
  const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [isQppVersionSelected, setIsQppVersionSelected] = useState(true);
  const [env, setEnv] = useState("");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    // updateGWLForm("IsContractIdAvailable", value);
    if (value === "no") {
      updateGWLForm("IsContractIdAvailable", "no");
      updateGWLForm("SAPContractID", "0000000000");
      updateGWLForm("EndToEndUId", "");
      updateGWLForm("ContractAvailabilityDate", createMaxDate(14));
      setSapContractCodeLength(10);
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateGWLForm("SAPContractID", "");
      updateGWLForm("ClientName", "");
      updateGWLForm("EndToEndUId", "");
      setSapContractCodeLength(0);
    }
  };

  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);

  if (config) {
    //updateGWLForm("ClientName", "")
    updateGWLForm("EndToEndUId", "")
    updateGWLForm("Company", "")
    updateGWLForm("AvanadeCountry", "")
    updateGWLForm("AccentureCountry", "")
    updateGWLForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updateGWLForm("ClientName", externalClientData[0])
      updateGWLForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updateGWLForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateGWLForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateGWLForm("AccentureCountry", externalClientData[4])
      if (isChecked && externalClientData[5] !== undefined) {
        if (values.GDPR === 'no')
          updateGWLForm("GDPR", externalClientData[5] ? "yes" : "no")
      }
      updateGWLForm("ContractAvailabilityDate", "")
      updateGWLForm("IsContractIdAvailable", "yes")
    }
  }

  // Real-time validation for submit button state (integrates with PlatformLicenseStepper)
  if (!config) {
    (isConcurrentUsersValid &&
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isServiceNowTicketValid && isProjectNameValid && !errorADGroup && !errorSADGroup && !isADSADUnique && isTeamNameSelected && isQppVersionSelected && isPocvalid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else {
    (isServiceNowTicketValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isProjectNameValid && !errorADGroup && !errorSADGroup && !isADSADUnique && isTeamNameSelected && isQppVersionSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  const [appsIntegList, setAppsIntegList] = React.useState({
    Quasarpp: true,
    AD: false,
    ATR: false
  })

  const { Quasarpp, AD, ATR } = appsIntegList;

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
      updateGWLForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateGWLForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateGWLForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    } else {
      const { value } = event.target;
      event.preventDefault();
      updateGWLForm(fieldName, value);
      // if (fieldName === "Environment") {
      //   getSelectedEnvironment(value);
      // }
      if (fieldName === "RITM") {
        setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
      }
      if (fieldName === "WBSEcode") {
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "ConcurrentUsers") {
        setIsConcurrentUsersValid(checkConcurrentUsers(value));
      }
      if (fieldName === "BenefitsExpected") {
        if (value[0] === "0") {
          setIsBenefitsExpectedValid(false);
        } else {
          setIsBenefitsExpectedValid(checkBenefitsExpected(value));
        }
      }
      if (fieldName === "AdminDistributionGroup") {
        if (value == values.SuperAdminDistributionGroup) {
          setIsADSADUnique(true)
        } else {
          setIsADSADUnique(false)
        }
        if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
          setErrorADGroup(true)
        } else {
          setErrorADGroup(false)
        }
      }
      if (fieldName === "SuperAdminDistributionGroup") {
        if (value == values.AdminDistributionGroup) {
          setIsADSADUnique(true)
        } else {
          setIsADSADUnique(false)
        }
        if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
          setErrorSADGroup(true)
        } else {
          setErrorSADGroup(false)
        }
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }

      if (fieldName === "TicketMonthlyVolume") {
        if (value[0] === "0") {
          setIsMonthlyTicketVolumeValid(false);
        } else {
          setIsMonthlyTicketVolumeValid(checkMonthlyTicketVolume(value));
        }
      }
      //update aSelectedInstance as other step relies on this data
      if (aSelectedInstanceFields[fieldName]) {
        const afieldDetails = aSelectedInstanceFields[fieldName];
        afieldDetails.type === "string" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value,
          });
        afieldDetails.type === "object" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value: {
              Value: value,
            },
          });
      }
      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "AppsIntegration") {
        // setSelectedApps(value)        
        setAppsIntegList({
          ...appsIntegList,
          [event.target.name]: event.target.checked,
        });
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateGWLForm("DeploymentRegion", "");
      }
      if (fieldName === "DeploymentRegion") {
        if (value == "sydney") {
          setRegionCode("dh")
        } else if (value == "virginia") {
          setRegionCode("dh1")
        } else if (value == "frankfurt") {
          setRegionCode("dh2")
        } else if (value == "singapore") {
          setRegionCode("dh3")
        } else if (value == "tokyo") {
          setRegionCode("dh4")
        } else if (value == "ireland") {
          setRegionCode("dh5")
        } else if (value == "london") {
          setRegionCode("dh6")
        } else {
          setRegionCode("[__]")
        }
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateGWLForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateGWLForm("Tier", "")
        } else {
          setEnv("")
          updateGWLForm("Tier", "")
        }
      }
      if (fieldName === "QppVersion") {
        if (value !== undefined || value !== null) {
          updateGWLForm("QppVersion", value);
          setIsQppVersionSelected(true);
        } else {
          setIsQppVersionSelected(false);
        }
      }

    }
  };

  const apps = "AD,ATR,Quasar++";
  const appList = apps.split(",");
  const sortedAppList = appList.sort();

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updateGWLForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    // const value = event.target.value;
    re.test(value) && updateGWLForm(fieldName, value);
    setDomainContextRoot(value)
  };

  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);


  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateGWLForm(fieldName, value);
  };

  updateGWLForm("ConfigurationType", configurationType);
  getSelectedEnvironment(env);
  updateGWLForm("Environment", env);


  const validateInputFields = (step) => {
    // If not final submit, allow navigation (no validation)
    if (step !== 'submit') {
      return true;
    }

    let ispass = true;
    const missingFields = [];

    // Final submit validation - validate ALL fields across all steps
    const allFieldsRequired = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DataClassification',
      'TeamName',
      'RequestNotes',
      'DeploymentRegion',
      'DomainContextRoot',
      'Environment',
      'AdminDistributionGroup',
      'TentativeServiceEndDate',
      'OpenAITextEmbeddingsModel',
      'SuperAdminDistributionGroup',
      'QppVersion'
    ];

    // Add conditional required fields
    if (!config) {
      if (isChecked) {
        allFieldsRequired.push('SAPContractID');
      } else {
        allFieldsRequired.push('Pocdetails', 'ClientName');
      }

      // RITM is always mandatory regardless of SAP Contract checkbox
      allFieldsRequired.push('RITM');
      allFieldsRequired.push('UsersDistributionGroup');
    }

    if (values.Environment === "Production") {
      allFieldsRequired.push('Tier');
    }

    // Check for missing fields (basic empty validation - red borders handled by hook)
    for (const fieldname of allFieldsRequired) {
      if (fieldname === "WBSEcode") {
        // WBSE validation: empty OR API validation failed
        if (!values[fieldname] || values[fieldname] === "" || !isWBSEValid) {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (fieldname === "RITM") {
        if (!values.RITM || values.RITM === "" || values.RITM === null) {
          missingFields.push(fieldname);
          ispass = false;
        } else if (serviceNowAPIValid === false) {
          missingFields.push(`${fieldname} (not found in records)`);
          ispass = false;
        } else if (!isServiceNowTicketValid) {
          missingFields.push(`${fieldname} (invalid format)`);
          ispass = false;
        }
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        missingFields.push(fieldname);
        ispass = false;
      } else if (fieldname === "Pocdetails") {
        if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (values[fieldname] === "" || values[fieldname] === undefined || values[fieldname] === null) {
        missingFields.push(fieldname);
        ispass = false;
      }
    }

    // Use the hook to handle validation results (red borders + dialog)
    handleValidationResult(ispass, missingFields, formClickSubmit);
    return ispass;
  }

  useEffect(() => {
    var res = [];
    for (const [key, value] of Object.entries(appsIntegList)) {
      if (value) {
        res.push(key);
      }
    }
    updateGWLForm("AppsIntegration", res);
  }, [appsIntegList]);

  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={8}
        validateInputFields={validateInputFields}
        ClientContractFields={

          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a Contract ID available?
                </ConfigurationFormLabel>


                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""}

            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 42 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }

            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponentv2
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        idkey="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config) &&
                  <Grid item xs={4}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid, setServiceNowAPIValid, configurationType)}
                  </Grid>
                }
                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )}
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >}

                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>
                {config &&
                  <Grid item xs={8}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid, setServiceNowAPIValid, configurationType)}
                  </Grid>
                }
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                </Grid >

                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected, 'gtaad', configurationType)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                {/* <Grid item xs={4}>
                 { (!config && !isChecked || config) &&
                  FormField.ClientNamePlatformInternal(handleChange, values)}
              </Grid > */}

                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            {/* {!config ? <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}.mywizard-aiops.com/{domainContextRoot}</span></p> : ""} */}
            {values.AppsIntegration.includes("Quasarpp") &&
              <p>Expected Custom Knowledge Manager UI URL: <span style={{ color: " #0041F0" }}>https://{regionCode}-{domainContextRoot}quasar.mywizard-aiops.com/</span></p>
            }
            {values.AppsIntegration.includes("AD") &&
              <>
                <p>Expected Custom AD UI URL: <span style={{ color: " #0041F0" }}>https://genwizard-{domainContextRoot}.mywizard-aiops.com</span></p>
                <p> Expected Custom AD API URL: <span style={{ color: " #0041F0" }}>https://genwizard-{domainContextRoot}-api.mywizard-aiops.com</span></p>
              </>
            }
            {values.AppsIntegration.includes("ATR") &&
              <p> Expected Custom Auto Resolver UI URL: <span style={{ color: " #0041F0" }}>https://{regionCode}-{domainContextRoot}.mywizard-aiops.com/atr/signin</span></p>
            }
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >

                <Grid item xs={12}>
                  {PlatformFormField.GDPRPlatformField(
                    values,
                    handleChange,
                    isGDPR,
                    classes,
                    config,
                    isChecked,
                    externalClientData
                  )}
                </Grid>

                <Grid item xs={3}>
                  {PlatformFormField.DeploymentRegionGenWizardPlatformField(
                    values,
                    handleChange,
                    isGDPR,
                    values.TeamName,
                    configurationType
                  )}
                </Grid>

                <Grid item xs={6}>
                  {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                    values,
                    handleChangeRootSuggestions,
                    // handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    rootWrongFormatHint,
                    externalClientData,
                    domainContextRoot,
                    isLoading
                  ) : PlatformFormField.DomainContextRootPlatformField(
                    values,
                    handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    isLoading
                  )}
                </Grid>
                {/* <Grid item xs={3}>
                  {PlatformFormField.EnvironmentPlatformField(values, handleChange)}
                </Grid> */}
                <Grid item xs={3}>
                  {PlatformFormField.EnvironmentField(values, handleChange, env)}
                </Grid>
                {values.Environment === "Production" && (
                  <>
                    <Grid item xs={3}>
                      {PlatformFormField.TierPlatformField(
                        values,
                        handleChange
                      )}
                      {values.Tier && (
                        <div>
                          <em style={{ fontSize: "small", color: "#0033CC" }}>
                            {/* Cost of {values.Tier} is:{" "} */}
                            Infra & service cost per month:{" "}
                            {priceConfig.priceToTier[values.Tier] &&
                              priceConfig.priceToTier[values.Tier].price}{" "}
                          </em>
                        </div>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            </div>
          </div>
        }
        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={4}>
                {FormField.AdminDistributionGroupField(handleChange, values)}
              </Grid>
              {!config &&
                <Grid item xs={4}>
                  {FormField.UsersDistributionGroupField(handleChange, values)}
                </Grid>
              }
              <Grid item xs={4}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
              <Grid item xs={4}>
                {FormField.OpenAITextEmbeddingsModel(handleChange, values)}
              </Grid>
              <Grid item xs={4}>
                {FormField.SuperAdminDistributionGroupField(handleChange, values, errorSADGroup, isADSADUnique)}
              </Grid>
              <Grid item xs={4}>
                {FormField.QuasarPPVersionSelect(handleChange, values, isQppVersionSelected)}
              </Grid>
              {!config &&
                <Grid item xs={6}>
                </Grid>
              }
              <Grid
                container
                spacing={2}
              >

                <Grid item xs={3}>
                  <StyledFormControl variant="outlined" margin="dense">
                    <FormLabel component="legend" style={{ paddingTop: "10px" }}>
                      Applications To Provision
                    </FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        style={{ paddingTop: "10px" }}
                        control={
                          <Checkbox
                            checked={Quasarpp}
                            disabled
                            onChange={(e) => handleChange(e, "AppsIntegration")}
                            name="Quasar++"
                          />
                        }
                        label="Knowledge Manager"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={AD}
                            onChange={(e) => handleChange(e, "AppsIntegration")}
                            name="AD" />
                        }
                        label="AD"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={ATR}
                            onChange={(e) => handleChange(e, "AppsIntegration")}
                            name="ATR"
                          />
                        }
                        label="Auto Resolver"
                      />
                    </FormGroup>
                  </StyledFormControl>
                </Grid>

                <Grid item xs={9}>
                  <div style={{ padding: '15px 10px' }}>
                    <label style={{ margin: '0' }}>Expected Custom URL</label>
                    {values.AppsIntegration.includes("Quasarpp") &&
                      <div style={{ width: '70%', display: 'flex', height: 'auto', margin: '7px 0' }}>
                        <div style={{ width: '240px' }}>Knowledge Manager UI:</div>
                        <div style={{ width: 'calc(100% - 130px)', display: 'flex', height: 'auto', flexDirection: 'column' }}>
                          <span style={{ color: " #0041F0", fontSize: '.9em' }}>https://{regionCode}-{domainContextRoot}quasar.mywizard-aiops.com/</span>
                        </div>
                      </div>
                    }
                    {values.AppsIntegration.includes("AD") &&
                      <div style={{ width: '70%', display: 'flex', height: 'auto', margin: '7px 0' }}>
                        <div style={{ width: '240px' }}>AD UI:</div>
                        <div style={{ width: 'calc(100% - 130px)', display: 'flex', height: 'auto', flexDirection: 'column' }}>
                          <span style={{ color: " #0041F0", fontSize: '.9em' }}>https://genwizard-{domainContextRoot}.mywizard-aiops.com</span>
                        </div>
                      </div>
                    }
                    {values.AppsIntegration.includes("AD") &&
                      <div style={{ width: '70%', display: 'flex', height: 'auto', margin: '7px 0' }}>
                        <div style={{ width: '240px' }}>AD API:</div>
                        <div style={{ width: 'calc(100% - 130px)', display: 'flex', height: 'auto', flexDirection: 'column' }}>
                          <span style={{ color: " #0041F0", fontSize: '.9em' }}>https://genwizard-{domainContextRoot}-api.mywizard-aiops.com</span>
                        </div>
                      </div>
                    }
                    {values.AppsIntegration.includes("ATR") &&
                      <div style={{ width: '70%', display: 'flex', height: 'auto', margin: '7px 0' }}>
                        <div style={{ width: '240px' }}>Auto Resolver UI:</div>
                        <div style={{ width: 'calc(100% - 130px)', display: 'flex', height: 'auto', flexDirection: 'column' }}>
                          <span style={{ color: " #0041F0", fontSize: '.9em' }}>https://{regionCode}-{domainContextRoot}.mywizard-aiops.com/atr/signin</span>
                        </div>
                      </div>
                    }
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        }
        history={history}
      >
      </GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions >
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}

      {/* Validation Error Dialog */}
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  values: state.fui.GWLForm,
  isRootExist: state.fui.isRootExist,
  isWBSEValid: state.fui.isWBSEValid,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
  updateGWLForm: fuiRedux.updateGWLForm,
  updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
  checkDomainAvaliable: fuiRedux.checkRootExisted,
  fetchExternalClientDetails,
  checkIsWBSEValid
})(withRouter(GenWizardPlatform));
